import { RecoilProviderWrapper } from "./src/containers/RecoilProviderWrapper"
export const wrapRootElement = RecoilProviderWrapper
